import { useState, useCallback } from "react";
import { InputDS, ButtonDS, CheckOutlined } from "@qivia/ui";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { updateMileageAsync } from "../transactionsSlice";
import { PayloadForUpdateTransactionDetails } from "../transactionsAPI";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectManager } from "../../homeSlice";

interface UpdateTransactionDetailsInputProps {
  value?: string;
  informationLabel: string;
  transactionUuid: string;
}

export const UpdateTransactionDetailsInput = ({
  value,
  informationLabel,
  transactionUuid,
}: UpdateTransactionDetailsInputProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const manager = useAppSelector(selectManager);

  const [inputValue, setInputValue] = useState<string>(value || "");

  const handleUpdateTransactionDetails = useCallback(() => {
    if (!manager) return;
    const payload = {
      transactionUuid: transactionUuid,
      updatedBy: manager.uuid,
      [informationLabel as keyof PayloadForUpdateTransactionDetails]: isNaN(
        Number(inputValue),
      )
        ? inputValue
        : Number(inputValue),
    } as PayloadForUpdateTransactionDetails;

    // LATER HANDLE OTHER INFORMATIONS
    void dispatch(updateMileageAsync(payload));
  }, [manager, transactionUuid, informationLabel, inputValue, dispatch]);

  return (
    <StyledRow>
      <InputDS
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={t(
          `transactions.updateDetails.${informationLabel}.input.placeholder`,
        )}
        withoutSpacerBottom
      />
      <ButtonDS
        singleIcon={{ icon: <CheckOutlined />, size: "S" }}
        onClick={handleUpdateTransactionDetails}
        height="2.5"
        format="hug"
        buttonType="primary"
      />
    </StyledRow>
  );
};

const StyledRow = styled.div`
  display: flex;
  align-items: center;
`;
